import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

const TOPICS_KEY = ["academy-topics", "owner"];
const PROPOSALS_KEY = ["topic-proposals"];

// ── Academy topic catalogue (owner) ─────────────────────────────────────────
function useAcademyTopicsAdmin() {
  return useQuery({
    queryKey: TOPICS_KEY,
    queryFn: () => apiClient.get("/api/v1/academy-topics/").then((r) => r.data),
  });
}

function useCreateAcademyTopic() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      apiClient.post("/api/v1/academy-topics/", body).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["academy-topics"] });
    },
  });
}

function useUpdateAcademyTopic() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) =>
      apiClient
        .patch(`/api/v1/academy-topics/${id}/`, body)
        .then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["academy-topics"] });
    },
  });
}

function useDeleteAcademyTopic() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => apiClient.delete(`/api/v1/academy-topics/${id}/`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["academy-topics"] });
    },
  });
}

// ── Topic proposals (owner review) ──────────────────────────────────────────
function useTopicProposals(status) {
  return useQuery({
    queryKey: [...PROPOSALS_KEY, status ?? "all"],
    queryFn: () =>
      apiClient
        .get("/api/v1/topic-proposals/", { params: status ? { status } : {} })
        .then((r) => r.data),
  });
}

function useApproveProposal() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) =>
      apiClient.post(`/api/v1/topic-proposals/${id}/approve/`).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: PROPOSALS_KEY });
      qc.invalidateQueries({ queryKey: ["academy-topics"] });
    },
  });
}

function useRejectProposal() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, review_note }) =>
      apiClient
        .post(`/api/v1/topic-proposals/${id}/reject/`, { review_note })
        .then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: PROPOSALS_KEY });
    },
  });
}

export {
  useAcademyTopicsAdmin,
  useCreateAcademyTopic,
  useUpdateAcademyTopic,
  useDeleteAcademyTopic,
  useTopicProposals,
  useApproveProposal,
  useRejectProposal,
};
